module.exports = __webpack_public_path__ + "static/media/Illus-SideVeggie@3x.eac34297.png";